<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6fViQW/tc-custom/9781466803206.jpg?1737776867096" alt="This image is the cover for the book The World of the End"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The World of the End
      </h1>
      <p class="bookDescription body article font2">
        <b>A fixer of fictional endings must confront his own in this “astonishingly inventive, funny and totally fascinating” novel of the afterlife (<i>Kirkus Reviews</i>, starred review),</b><br/><br/>As an epilogist—one who writes the ending of stories others are unable to finish—Ben Mendelssohn appreciates an unexpected denouement. But the untimely demise of his beloved wife is beyond his capacity for coping. Marian was more than his life partner; she was the fiber that held together all that he is. And Ben is willing to do anything, even enter the unknown beyond, for a chance to be with her again.<br/><br/>One bullet to the brain later, Ben is in the Other World: a vast and curiously secular place unlike anything he could have imagined: a realm of sprawling cities where the deceased of every age live an eternal second life, and where forests of family trees are tended by mysterious humans who never lived in the previous world. But Ben cannot find Marian.<br/><br/>Desperate for a reunion, he enlists an afterlife investigator to track her down, little knowing that his search is entangled in events that continue to unfold in the world of the living. It is a search that confronts Ben with the best and worst of human nature; the resilience and fragility of love; and truths that will haunt him through eternity.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ofir Touché Gafla
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ba867ce8